<ng-container *transloco="let t">
  <ng-container *ngIf="step$ | async as step">
    <form id="inputForm" *ngIf="inputForm$ | async as inputForm" [formGroup]="inputForm"
      (ngSubmit)="submit(inputForm, step)">
      <div class="mt-2 text-left">
        <small>{{t('manage-employee-session.requiredFields')}}</small>
      </div>
      <div class="mt-2 row">
        <div class="col-4">
          <gt-enhanced-autocomplete label="{{t('manage-employee-session.employee')}}" formControlName="employee"
            (changed)="selectEmployee($event, inputForm)" [searchFn]="employeeSearchFn" [labelFn]="employeeLabelFn"
            [valueMode]="'object'">
          </gt-enhanced-autocomplete>
        </div>
        <ng-container *ngIf="showRegistrationNumber$ | async">
          <div class="col-2">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>{{t('manage-employee-session.registrationNumber')}}</mat-label>
              <input matInput type="text" formControlName="registrationNumber" />
            </mat-form-field>
          </div>
        </ng-container>
        <ng-container *ngIf="showContract$ | async">
          <div class="col-3">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>{{t('manage-employee-session.contractStartOn')}}</mat-label>
              <mat-datepicker #startPicker></mat-datepicker>
              <input matInput #startDate [matDatepicker]="startPicker" (click)="startPicker.open()"
                formControlName="contractStartOn" />
              <a matSuffix (click)="startPicker.select(undefined)" [hidden]="!startDate.value">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </a>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>{{t('manage-employee-session.contractEndOn')}}</mat-label>
              <mat-datepicker #endPpicker></mat-datepicker>
              <input matInput #endDate [matDatepicker]="endPpicker" (click)="endPpicker.open()"
                formControlName="contractEndOn" />
              <a matSuffix (click)="endPpicker.select(undefined)" [hidden]="!endDate.value">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
              </a>
            </mat-form-field>
          </div>
        </ng-container>
        <ng-container *ngIf="showPurpose$ | async">
          <div class="col-4">
            <gt-enhanced-autocomplete label="{{t('manage-employee-session.purpose')}}" formControlName="purpose"
              [searchFn]="purposeSearchFn" [labelFn]="purposeLabelFn" [valueMode]="'object'"
              [displayedValue]="purposeLabel$ | async">
            </gt-enhanced-autocomplete>
          </div>
        </ng-container>
        <ng-container *ngIf="showDeliveryPoint$ | async">
          <div class="col-4">
            <gt-enhanced-autocomplete label="{{t('manage-employee-session.deliveryPoint')}}" #deliveryPointCtl
              formControlName="deliveryPoint" [searchFn]="deliveryPointSearchFn" [labelFn]="deliveryPointLabelFn"
              (changed)="selectDeliveryPoint($event)" [valueMode]="'object'"
              [displayedValue]="deliveryPointLabel$ | async">
            </gt-enhanced-autocomplete>
          </div>
        </ng-container>
        <ng-container *ngIf="showDepartment$ | async">
          <div class="col-4">
            <gt-enhanced-autocomplete label="{{t('manage-employee-session.department')}}" formControlName="department"
              [searchFn]="departmentSearchFn" [labelFn]="departmentLabelFn" [valueMode]="'object'"
              [displayedValue]="departmentLabel$ | async">
            </gt-enhanced-autocomplete>
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="showMeasures$ | async">
        <div class="mt-2 text-left">
          <h4>{{t('manage-employee-session.measures')}}</h4>
        </div>
        <div class="row">
          <div class="col">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>{{t('manage-employee-session.chest')}}</mat-label>
              <input matInput formControlName="chest" type="number" />
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>{{t('manage-employee-session.waist')}}</mat-label>
              <input matInput formControlName="waist" type="number" />
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>{{t('manage-employee-session.hip')}}</mat-label>
              <input matInput formControlName="hip" type="number" />
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>{{t('manage-employee-session.pelvis')}}</mat-label>
              <input matInput formControlName="pelvis" type="number" />
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field class="w-100" appearance="fill">
              <mat-label>{{t('manage-employee-session.shoes')}}</mat-label>
              <input matInput formControlName="shoes" type="number" />
            </mat-form-field>
          </div>
        </div>
      </ng-container>
    </form>
  </ng-container>
</ng-container>
